import React, { FunctionComponent } from "react";
import useCustomizationContext from "../../../../hooks/useCustomizationContext";
import {
  Template,
  TemplateDateCellForcedImageDefinition,
  TemplateForcedImageDefinition,
} from "../../../../types/customization/template";
import { imageUrlFromAssetDefinition } from "../../../../utils/customization/asset";
import { sizeDmmToMm, sizeMmToPx } from "../../../../utils/customization/box";
import { findAssetDefinition } from "../../../../utils/customization/finders";
import "./style.scss";

interface Props {
  elementDefinition: TemplateForcedImageDefinition | TemplateDateCellForcedImageDefinition;
  ppmm: number;
  template: Template;
}

const ForcedImage: FunctionComponent<Props> = ({ elementDefinition, ppmm, template }) => {
  const { configuration } = useCustomizationContext();
  const assetDefinition = findAssetDefinition(elementDefinition.assetKey, template);

  const elementSizePx = sizeMmToPx(sizeDmmToMm(elementDefinition), ppmm);

  const assetUrlTemplate = configuration && configuration.assetUrlTemplate;
  const imageUrl = imageUrlFromAssetDefinition(
    assetDefinition,
    elementSizePx.width.value,
    assetUrlTemplate
  );

  return <img alt="" className="ForcedImage" draggable={false} src={imageUrl} />;
};

export default ForcedImage;
